import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { DictionaryEntry } from '../types';

interface AlphabetNavProps {
  selectedLetter: string | null;
  onLetterClick: (letter: string | null) => void;
  data: DictionaryEntry[];
}

export const AlphabetNav = ({ selectedLetter, onLetterClick, data }: AlphabetNavProps) => {
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  
  // Calcule quelles lettres ont des entrées
  const availableLetters = useMemo(() => {
    return new Set(data.map(entry => entry.letter.toUpperCase()));
  }, [data]);

  return (
    <motion.nav
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.6 }}
      className="max-w-6xl mx-auto px-6 py-8"
      aria-label="Navigation alphabétique"
    >
      <div className="flex flex-wrap justify-center gap-2">
        {alphabet.map((letter, index) => {
          const isAvailable = availableLetters.has(letter);
          const isSelected = selectedLetter === letter;
          
          return (
            <motion.button
              key={letter}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.6 + index * 0.02 }}
              onClick={() => isAvailable && onLetterClick(letter)}
              disabled={!isAvailable}
              className={`
                w-11 h-11 rounded-lg font-serif font-bold text-lg
                transition-all duration-300
                ${isAvailable 
                  ? isSelected
                    ? 'bg-rose-500 text-white scale-110 shadow-lg'
                    : 'bg-white hover:bg-rose-50 text-slate-800 hover:text-rose-500 hover:scale-110 hover:shadow-md border-2 border-slate-200 hover:border-rose-500'
                  : 'bg-slate-100 text-slate-300 cursor-not-allowed opacity-40'
                }
              `}
              aria-label={`Filtrer par lettre ${letter}`}
              aria-pressed={isSelected}
            >
              {letter}
            </motion.button>
          );
        })}
      </div>
    </motion.nav>
  );
};
